var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loader-div",attrs:{"id":_vm.id,"title":_vm.message}},[_c('img',{attrs:{"src":require("../assets/error.png"),"width":"24","alt":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }